import { CONTAINER } from './LayoutTypes';
const CUSTOM_CONTAINER = 'CUSTOM_CONTAINER';

/**
* Finds the parent page of the given layout item, or the
* CUSTOM_CONTAINER constant if there is no parent page.
*/
export default function getParentPage(state, item) {
  const { layoutItems, pages } = state.website;
  const parentLayoutItem = layoutItems[item.layout.parentId];
  if (parentLayoutItem.layout.type === CONTAINER) {
    const pageId = Object.keys(pages).find(id =>
      pages[id].rootLayoutItemIds.includes(parentLayoutItem.id));
    return pages[pageId] || CUSTOM_CONTAINER;
  }
  return getParentPage(state, parentLayoutItem);
}
